import { useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight, Check, Sparkles } from "lucide-react";
import { fr } from "../content/fr";
import { IMG } from "../lib/images";
import { fetchAngle } from "../lib/api";
import { track } from "../lib/tracking";
import Seo from "../components/Seo";
import Header from "../components/Header";
import { Reveal, LiveBadge } from "../components/ui-bits";

export default function AdLanding() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { data: angle, isError, isLoading } = useQuery({ queryKey: ["angle", slug], queryFn: () => fetchAngle(slug), retry: false });

  useEffect(() => { if (angle) track("ViewContent", { custom: { content_name: `lp_${slug}` } }); }, [angle, slug]);

  const go = () => { track("InitiateCheckout", { custom: { content_name: `lp_${slug}` } }); navigate("/pilote"); };

  return (
    <div>
      <Seo
        routeKey="/o"
        path={`/lp/${slug}`}
        title={angle ? `${angle.titre} | VIRALYA` : undefined}
        description={angle ? angle.hook : undefined}
      />
      <Header />
      <main className="page" style={{ paddingBottom: 100 }}>
        <div className="container">
          {isLoading && <p className="muted">Chargement…</p>}
          {isError && (
            <div className="glass card center" style={{ padding: "3rem" }} data-testid="lp-notfound">
              <h1 className="h2">Page introuvable</h1>
              <Link to="/" className="btn btn--primary" style={{ marginTop: "1.5rem" }}>Accueil</Link>
            </div>
          )}
          {angle && (
            <>
              <div className="offer-wrap" data-testid="lp-hero">
                <Reveal>
                  <span className="hero__badge"><Sparkles size={14} color="var(--brand-violet)" /> {angle.secteur}</span>
                  <h1 className="h1" style={{ marginTop: "1rem" }}>{angle.titre}</h1>
                  <p className="lead" style={{ marginTop: "1.2rem" }}>{angle.hook}</p>
                  <button className="btn btn--primary" style={{ marginTop: "1.8rem" }} onClick={go} data-testid="lp-cta-hero">{fr.ad.cta} <ArrowRight size={16} /></button>
                  <p className="hero__note">{fr.ad.sub}</p>
                </Reveal>
                <Reveal delay={0.1} style={{ position: "relative", borderRadius: 24, overflow: "hidden", boxShadow: "var(--card-shadow)" }}>
                  <img src={IMG.vslCover} alt="" style={{ width: "100%", display: "block" }} />
                  <div style={{ position: "absolute", left: 16, top: 16 }}><LiveBadge label="STUDIO IA" /></div>
                </Reveal>
              </div>

              <div style={{ maxWidth: 720, margin: "3rem auto 0" }}>
                {(angle.blocks || []).slice(0, 4).map((b, i) => (
                  <Reveal className="glass card" key={i} delay={i * 0.05} style={{ marginBottom: "1rem", display: "flex", gap: "1rem" }}>
                    <Check size={22} color="var(--brand-violet)" style={{ flexShrink: 0, marginTop: 2 }} />
                    <div><h3 className="card__title">{b.h}</h3><p className="card__desc">{b.p}</p></div>
                  </Reveal>
                ))}
                <div className="center" style={{ marginTop: "2rem" }}>
                  <button className="btn btn--primary" onClick={go} data-testid="lp-cta-bottom">{fr.ad.cta} <ArrowRight size={16} /></button>
                </div>
              </div>
            </>
          )}
        </div>
      </main>

      {angle && (
        <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 60, background: "var(--bg-overlay)", backdropFilter: "blur(14px)", borderTop: "1px solid var(--border-subtle)", padding: "0.75rem var(--gutter)" }}>
          <div className="container" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "1rem" }}>
            <strong style={{ fontFamily: "var(--font-head)" }}>{angle.secteur} · Studio vidéo IA</strong>
            <button className="btn btn--primary" onClick={go} data-testid="lp-cta-sticky">{fr.ad.stickyCta} <ArrowRight size={15} /></button>
          </div>
        </div>
      )}
    </div>
  );
}
